// extracted by mini-css-extract-plugin
export default {"root":"src-client-__notistack_root","variantIcon":"src-client-__notistack_variantIcon"};